import { render, staticRenderFns } from "./CreateStage.vue?vue&type=template&id=cfd57c4a&"
import script from "./CreateStage.vue?vue&type=script&lang=js&"
export * from "./CreateStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports